export default function EmptyState({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <div className="surface-card px-6 py-12 text-center">
      <h3 className="mb-2 text-2xl font-bold text-foreground">{title}</h3>
      <p className="mx-auto max-w-xl text-sm text-muted-foreground">{description}</p>
    </div>
  );
}
